import styled from '@emotion/styled'
import { Box, Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import Footer from './Footer'

const SignUpBox = styled(Box)({
    background: '#252525',
    height: '100vh',
})


const CreateAccount = () => {
    console.log('this is account page...')
  return ( <SignUpBox>
                <Box style={{height: 'auto', width: '90vw',  margin: 'auto', position: 'relative', top: '10rem', background: '#252525'}}>
                    <h2 style={{lineHeight: '3rem', color: "white"}}>Register</h2>
                    <h5 style={{color: 'white'}}>Please fill in the fields below:</h5>
                    <form action="" style={{display: 'flex', flexDirection: 'column', width: '21rem', margin: 'auto', gap: '1rem'}}>
                        <input type="text" style={{width: '20rem', margin: 'auto', height: '2.5rem', borderRadius: '0.5rem', border: '1px solid gray', background: '#252525',}} required placeholder='First Name' />
                        <input type="text" style={{width: '20rem', margin: 'auto', height: '2.5rem', borderRadius: '0.5rem', border: '1px solid gray', background: '#252525',}} required placeholder='Last Name' />
                        <input type="text" style={{width: '20rem', margin: 'auto', height: '2.5rem', borderRadius: '0.5rem', border: '1px solid gray', background: '#252525',}} required placeholder='Email' />
                        <input type="text" style={{width: '20rem', margin: 'auto', height: '2.5rem', borderRadius: '0.5rem', border: '1px solid gray', background: '#252525',}} required placeholder='Password' />
                        <Button style={{background: 'red', color: 'white', fontWeight: 'bold'}}>CREATE ACCOUNT</Button>
                    </form>
                    <h5 style={{color: 'white'}}>Already have an account?  
                        <Link to='/signup'>
                <span style={{color: 'white'}}><i>login</i></span>
                        </Link>
                    </h5>
                </Box>
                <Box style={{paddingTop: '12rem'}}>
                    <Footer />
                </Box>
                
            </SignUpBox>)
}

export default CreateAccount